// extracted by mini-css-extract-plugin
module.exports = {"select":"CustomSelectSelect_select__2XQpS"};